import React from 'react'
import { formatPrice } from 'common/helpers'

import Box from 'components/_new/layout/Box/Box'
import Text from 'components/_new/typography/Text/Text'
import RatingStars from 'components/rating/RatingStars/RatingStars'
import ProductImage from 'components/_new/ui/ProductImage/ProductImage'

import s from './ProductCardBase.scss'


const ProductCardBase = (props) => {
  const {
    brand, name, image, upchargePrice, rating,
    imageNode, imageAspectRatio, withGender, sex,
    nameTextProps = {}, brandTextProps = {},
  } = props

  return (
    <div className={s.productCardBase}>
      {
        Boolean(upchargePrice) && (
          <div className={s.upchargePrice}>
            +{formatPrice(upchargePrice, true, true, 0)}
          </div>
        )
      }
      <div className={s.imageContainer}>
        {
          imageNode || (
            <ProductImage src={image} aspectRatio={imageAspectRatio} />
          )
        }
      </div>
      {
        Boolean(rating >= 0) && (
          <Box pt="8">
            <RatingStars value={rating} md />
          </Box>
        )
      }
      {
        name && (
          <Text className={s.name} message={name} size="18-24" bold title={name} {...nameTextProps} />
        )
      }
      {
        brand && (
          <Text message={brand} color="brand" {...brandTextProps} />
        )
      }
      {
        Boolean(withGender && sex) && (
          <Text
            message={`${sex.charAt(0).toUpperCase()}${sex.slice(1)}`}
            color="gray-50"
            size="14-24"
          />
        )
      }
    </div>
  )
}


export default ProductCardBase
